// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"_Y-z","tooltip":"aZ-z","tooltipContent":"bZ-z","orderStatusWrapper":"cZ-z"};